import React from 'react';
import './SalesAgreement.css';

interface SalesAgreementProps {
  isChecked: boolean;
  onCheckChange: (checked: boolean) => void;
  showFullText?: boolean;
}

const SalesAgreement: React.FC<SalesAgreementProps> = ({ 
  isChecked, 
  onCheckChange,
  showFullText = false 
}) => {
  const [expanded, setExpanded] = React.useState(showFullText);

  return (
    <div className="sales-agreement-container">
      <details open={expanded} onToggle={(e) => setExpanded((e.target as HTMLDetailsElement).open)}>
        <summary className="agreement-summary">
          📄 Mesafeli Satış Sözleşmesi
        </summary>
        <div className="agreement-content">
          <h3>VILLA POLIKNE</h3>
          <h4>MESAFELİ KONAKLAMA SATIŞ SÖZLEŞMESİ</h4>
          <h4>İPTAL – İADE – GENEL KOŞULLAR</h4>
          
          <hr />
          
          <section>
            <h5>1. TARAFLAR VE SÖZLEŞMENİN KURULMASI</h5>
            <p>
              İşbu sözleşme, Villa Polikne ("İşletme") ile internet sitesi üzerinden rezervasyon yapan 
              tüketici ("Misafir") arasında elektronik ortamda kurulmuştur.
            </p>
            <p>
              Misafir, rezervasyonu tamamlayıp ödeme yaptığı anda bu sözleşme hükümlerini okuduğunu, 
              anladığını ve kabul ettiğini beyan eder.
            </p>
            <p>Rezervasyon, ödemenin tahsil edilmesi ile kesinleşir.</p>
          </section>

          <hr />

          <section>
            <h5>2. CAYMA HAKKI İSTİSNASI</h5>
            <p>
              6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği 
              uyarınca belirli bir tarihte veya dönemde ifa edilmesi gereken konaklama hizmetleri 
              cayma hakkı kapsamı dışındadır.
            </p>
            <p>
              Bu nedenle, misafir rezervasyonu tamamladıktan sonra işbu sözleşmede belirtilen iptal 
              şartları dışında tek taraflı cayma hakkına sahip değildir.
            </p>
          </section>

          <hr />

          <section>
            <h5>3. FİYAT VE ÖDEME</h5>
            <ul>
              <li>Fiyatlar rezervasyon anında sistemde görünen tutarlardır.</li>
              <li>Aksi belirtilmedikçe fiyatlara KDV ve konaklama vergisi dahildir.</li>
              <li>Online ödeme komisyonları misafire yansıtılabilir.</li>
              <li>Ödeme yapılmadan rezervasyon kesinleşmez.</li>
            </ul>
          </section>

          <hr />

          <section>
            <h5>4. İPTAL VE İADE KOŞULLARI</h5>
            <p>
              İptal talepleri yalnızca yazılı olarak (e-posta veya web sitesi iptal formu aracılığıyla) 
              yapılmalıdır. Telefonla yapılan bildirimler geçerli değildir.
            </p>
            
            <div className="cancellation-terms">
              <div className="term-item">
                <strong>4.1 Giriş tarihinden 14 gün öncesine kadar:</strong>
                <p>Rezervasyon bedelinin tamamı iade edilir.</p>
              </div>
              
              <div className="term-item">
                <strong>4.2 Giriş tarihine 14 gün – 3 gün kala:</strong>
                <p>Toplam rezervasyon bedelinin %50'si iade edilir.</p>
              </div>
              
              <div className="term-item">
                <strong>4.3 Giriş tarihine 3 gün kala ve sonrası:</strong>
                <p>İade yapılmaz.</p>
              </div>
            </div>
            
            <p><em>Süreler takvim günü esas alınarak hesaplanır.</em></p>
          </section>

          <hr />

          <section>
            <h5>5. NO-SHOW (TESİSE GELMEME)</h5>
            <p>
              Rezervasyon tarihinde tesise giriş yapılmaması halinde rezervasyon bedeli iade edilmez.
            </p>
          </section>

          <hr />

          <section>
            <h5>6. CHECK-IN SONRASI İADE YOKTUR</h5>
            <p>Misafir odayı teslim alıp giriş yaptıktan sonra;</p>
            <ul>
              <li>Oda fiilen görülmüş ve kabul edilmiş sayılır.</li>
              <li>Hizmetten yararlanmaya başlanmış kabul edilir.</li>
            </ul>
            <p>Bu aşamadan sonra;</p>
            <ul>
              <li>Odayı beğenmeme,</li>
              <li>Manzara beklentisi,</li>
              <li>Hava veya deniz koşulları,</li>
              <li>Çevresel faktörler,</li>
              <li>Gürültü,</li>
              <li>Kişisel memnuniyetsizlik,</li>
              <li>Keyfi erken ayrılış,</li>
            </ul>
            <p>gibi sebeplerle ücret iadesi yapılmaz.</p>
            <p><strong>Erken çıkış durumunda kullanılmayan günler için iade yapılmaz.</strong></p>
          </section>

          <hr />

          <section>
            <h5>7. KUSUR İDDİASI VE ÇÖZÜM PROSEDÜRÜ</h5>
            <p>Odaya ilişkin bir kusur iddiası varsa;</p>
            <ul>
              <li>Misafir durumu en geç check-in tarihinden itibaren 2 saat içinde yazılı olarak bildirmelidir.</li>
              <li>İşletmeye sorunun giderilmesi için makul süre tanınmalıdır.</li>
              <li>İşletme uygun görmesi halinde alternatif oda teklif edebilir.</li>
            </ul>
            <p>Alternatif oda teklifinin reddedilmesi halinde iade hakkı doğmaz.</p>
          </section>

          <hr />

          <section>
            <h5>8. MÜCBİR SEBEP</h5>
            <p>Aşağıdaki belgeli durumlarda, belge ibrazı şartıyla değerlendirme yapılabilir:</p>
            <ul>
              <li>Resmi sağlık kuruluşundan alınmış ağır hastalık raporu</li>
              <li>1. derece yakına ait ölüm belgesi</li>
              <li>Resmi makamlarca ilan edilmiş seyahat yasağı</li>
            </ul>
            <p>Belge sunulmayan mazeretler mücbir sebep sayılmaz.</p>
          </section>

          <hr />

          <section>
            <h5>9. HİZMET DIŞI KOŞULLAR VE SORUMLULUK SINIRI</h5>
            <p>Aşağıdaki durumlar işletmenin kontrolü dışında olup iade sebebi değildir:</p>
            <ul>
              <li>Hava koşulları</li>
              <li>Deniz durumu</li>
              <li>Elektrik veya altyapı kesintileri</li>
              <li>Bölgesel gürültü</li>
              <li>Çevresel faktörler</li>
              <li>Doğal yaşam unsurları</li>
            </ul>
          </section>

          <hr />

          <section>
            <h5>10. KAMPANYALI VE İNDİRİMLİ REZERVASYONLAR</h5>
            <p>
              Kampanyalı, erken rezervasyonlu veya özel fiyatlı rezervasyonlar için farklı iptal 
              koşulları uygulanabilir. Bu durum rezervasyon aşamasında açıkça belirtilir.
            </p>
          </section>

          <hr />

          <section>
            <h5>11. HASAR VE DAVRANIŞ SORUMLULUĞU</h5>
            <p>Tesise veya odaya verilen zararlar misafirden tahsil edilir.</p>
            <p>
              Diğer misafirleri rahatsız eden davranışlar halinde işletme konaklamayı sonlandırma 
              hakkına sahiptir. Bu durumda iade yapılmaz.
            </p>
          </section>

          <hr />

          <section>
            <h5>12. İADE SÜRESİ</h5>
            <p>
              Hak kazanılan iade tutarları, yazılı iptal talebinin işletmeye ulaşmasından itibaren 
              en geç 14 gün içinde ödeme yapılan yöntem ile iade edilir.
            </p>
          </section>

          <hr />

          <section>
            <h5>13. UYUŞMAZLIKLAR</h5>
            <p>Uyuşmazlıklarda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.</p>
          </section>

          <hr />

          <section>
            <h5>14. KİŞİ KONAKLAMA POLİTİKASI – ERKEK ERKEĞE KONAKLAMA</h5>
            <p>
              Villa Polikne, butik bir aile işletmesi konseptiyle hizmet vermektedir. Tesisin genel 
              huzuru, konsept bütünlüğü ve aile ortamının korunması amacıyla yalnızca erkek 
              misafirlerden oluşan grup veya tekil rezervasyonlar (erkek erkeğe konaklama) 
              kabul edilmemektedir.
            </p>
            <p>
              Misafir, rezervasyon aşamasında bu kuralı peşinen kabul etmiş sayılır. Bu kurala 
              aykırı şekilde veya yanıltıcı bilgi verilerek yapılan rezervasyonların işletme 
              tarafından tespit edilmesi halinde; Villa Polikne, tahsil edilen konaklama bedelini 
              misafire iade ederek rezervasyonu tek taraflı iptal etme hakkına sahiptir.
            </p>
          </section>
        </div>
      </details>

      <div className="agreement-checkbox">
        <label>
          <input 
            type="checkbox" 
            checked={isChecked}
            onChange={(e) => onCheckChange(e.target.checked)}
            required
          />
          <span className="checkbox-text">
            Bu sözleşmeyi okudum, anladım ve <strong>tüm koşulları kabul ediyorum</strong>.
          </span>
        </label>
      </div>
    </div>
  );
};

export default SalesAgreement;
